const kebabToCamel = (s) => s.replace(/-([a-z])/, (_, p1) => p1.toUpperCase());
const kebabToCamelObjectKeys = (obj = {}) => Object.keys(obj).reduce((result, key) => {
  result[kebabToCamel(key)] = obj[key];
  return result;
}, {});
const hasText = (child) => {
  if (!child) {
    return false;
  }
  if (typeof child === "string") {
    return child.trim().length > 0;
  }
  if (Array.isArray(child)) {
    return hasText(child[0]) || hasText(child[1]);
  } else if (typeof child === "object") {
    return hasText(child.props.children);
  } else {
    return false;
  }
};
const safariOrFirefox = () => {
  var _a;
  return /^((?!chrome).)*safari|firefox|fxios/i.test((_a = global.navigator) == null ? void 0 : _a.userAgent);
};

export { hasText, kebabToCamelObjectKeys, safariOrFirefox };
//# sourceMappingURL=textUtils.js.map
